import React from 'react';
import { ServicesNewsArticles } from '../NewsArticles';

function PLSNews() {
  return <ServicesNewsArticles line={'personal-lines'} />;
}

export default PLSNews;
